import React from 'react';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const EzParentProgramOverview = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter vidSrc={1195764252} />
    </div>
  );
};

export default EzParentProgramOverview;
